<!--
 * @message: 列表操作工具
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-10 10:19:05
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_tableListTools.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-28 13:53:51
-->
<template>
  <v-menu
    left
    v-model="showMenu"
    transition="slide-x-reverse-transition"
    class="pa-3 elevation-0"
    :close-on-content-click="true"
    :key="`menutools-${curkey}`"
    :close-on-click="true"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :disabled="disabled"
        v-on="on"
        :key="`btns--${curkey}`"
        v-if="curkey | showMore(showMore)"
      >
        <i class="material-icons-round">more_vert</i>
      </v-btn>
    </template>
    <v-list dense tile flat min-width="130" :elevation="0">
      <v-list-item tile v-if="viewBtn" @click.stop="onTriger('view')">
        <v-list-item-title>{{ $t(viewText) }}</v-list-item-title>
      </v-list-item>
      <v-list-item tile v-if="editBtn" @click.stop="onTriger('edit')">
        <v-list-item-title>{{ $t(editText) }}</v-list-item-title>
      </v-list-item>
      <v-list-item tile v-if="delBtn" @click.stop="onTriger('delete')">
        <v-list-item-title>{{ $t(delText) }}</v-list-item-title>
      </v-list-item>
      <v-list-item tile v-if="otherBtn" @click.stop="onTriger('other')">
        <v-list-item-title>{{ $t(otherText) }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "tableListTools",
  computed: {
    ...mapGetters(["isNeedSpace"]),
  },
  props: {
    title: { default: "", type: [String, Number] },
    uuid: { default: "", type: [String, Object, Array, Number] },
    table: { default: "", type: String },
    isUuid: { default: true, type: [Boolean, Number] },
    targetId: { default: "", type: String },
    curkey: {
      default: function () {
        return (Math.random() * 1000000000).toString();
      },
      type: String,
    },
    editText: {
      default: "label_essweb_list_components_tools_editBtnLabel",
      type: String,
    },
    viewText: {
      default: "label_essweb_list_components_tools_viewBtnLabel",
      type: String,
    },
    delText: {
      default: "label_essweb_list_components_tools_delBtnLabel",
      type: String,
    },
    otherText: {
      default: "",
      type: String,
    },
    disabled: { default: false, type: [Boolean, Number] },
    showDelete: { default: false, type: [Boolean, Number] },
    delBtn: { default: false, type: [Boolean, Number] },
    otherBtn: { default: false, type: [Boolean, Number] },
    viewBtn: { default: false, type: [Boolean, Number] },
    editBtn: { default: false, type: [Boolean, Number] },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  filters: {
    showMore(key, callback) {
      return callback();
    },
  },
  watch: {
    viewBtn(e, v) {},
    showDelete(val) {
      const that = this;
      if (val) {
        // const confirm = this.$confirm({
        //   text: "是否删除" + that.title + "?",
        //   title: "警告",
        //   button: [
        //     {
        //       text: "Cancel",
        //       show: true,
        //       ontap: function() {
        //         confirm.close().then(function(res) {
        //       that.onTriger("close");
        //     });
        //   },
        // },
        // {
        //       text: "Ok",
        //       show: true,
        //       ontap: function() {
        //         confirm.close().then(function(res) {
        // that.onTriger("confirm", that.uuid);
        //         });
        //       },
        //     },
        //   ],
        // });
      }
    },
  },
  methods: {
    showMore() {
      return this.delBtn || this.viewBtn || this.editBtn || this.otherBtn;
    },
    onTriger: function (action, uuid) {
      const that = this;
      this.showMenu = false;
      switch (action) {
        case "view":
          that.$emit("view", that.uuid, action);
          break;
        case "edit":
          if (that.isUuid) {
            that.$emit("edit", that.uuid, action);
          } else {
            that.$emit("edit", null, action);
          }
          break;
        case "confirm":
          that.$emit("confirm");
          break;
        case "close":
          that.$emit("close");
          break;
        case "other":
          that.$emit("other");
          break;
        case "delete":
          const confirm = that.$confirm({
            text:
              that.$t("message_essweb_list_components_tools_delDialogLabel") +
              (that.isNeedSpace ? " " : "") +
              that.title +
              "?",
            title: that.$t(
              "message_essweb_list_components_tools_delDialogTitle"
            ),
            button: [
              {
                text: that.$t(
                  "message_essweb_system_tools_dialogCancelBtnLabel"
                ),
                show: true,
                ontap: function () {
                  confirm.close().then(function (res) {});
                },
              },
              {
                text: that.$t(
                  "message_essweb_system_tools_dialogConfirmBtnLabel"
                ),
                show: true,
                ontap: function () {
                  confirm.close().then(function (res) {
                    if (that.table) {
                      that.$emit("delete", that.uuid, that.table);
                    } else {
                      that.$emit("delete", that.uuid);
                    }
                  });
                },
              },
            ],
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>
